<div class="primary-domain-confirmation-container">
  <mat-card-title>
    {{ 'PAGES.DOMAINS.MAKE_PRIMARY_MODAL.TITLE' | translate }}
  </mat-card-title>
  <mat-card-content>
    {{
      'PAGES.DOMAINS.MAKE_PRIMARY_MODAL.DESCRIPTION'
        | translate: { domain: domain }
    }}
  </mat-card-content>
  <mat-card-actions layout-align="end right">
    <button
      type="button"
      mat-raised-button
      color="accent"
      [disabled]="waiting"
      (click)="onOKClick()"
    >
      {{ 'PAGES.DOMAINS.MAKE_PRIMARY_MODAL.BUTTONS.MAKE_PRIMARY' | translate }}
    </button>
    <button
      type="button"
      mat-button
      color="accent"
      [disabled]="waiting"
      (click)="onCancelClick()"
    >
      {{ 'PAGES.DOMAINS.BUTTONS.CANCEL' | translate }}
    </button>
    <mat-spinner
      class="info-spinner-small"
      [style.visibility]="waiting ? 'visible' : 'hidden'"
      color="accent"
      [diameter]="30"
      [strokeWidth]="4"
    ></mat-spinner>
  </mat-card-actions>
</div>
